// App.js - Componente principal refactorizado
import React, { useState } from 'react';
import { ThemeProvider, createTheme, CssBaseline, Box, Typography } from '@mui/material';
import LoginForm from './components/LoginForm';
import Navigation from './components/Navigation';
import ClientesTab from './components/ClientesTab';
import HistoricoTab from './components/HistoricoTab';
import CalculatorForm from './components/calculator/CalculatorForm';

// Tema personalizado
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

// Credenciales hardcodeadas
export const CREDENTIALS = {
  username: 'admin',
  password: 'Ad*2025'
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setActiveTab(0);
  };

  const handleTabChange = (newValue) => {
    setActiveTab(newValue);
  };

  // Renderizado principal
  if (!isAuthenticated) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LoginForm onLogin={handleLogin} />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ flexGrow: 1 }}>
        <Navigation 
          activeTab={activeTab} 
          onTabChange={handleTabChange} 
          onLogout={handleLogout} 
        />
        
        {activeTab === 0 && <ClientesTab />}
        {activeTab === 1 && <HistoricoTab />}
        {activeTab === 2 && <CalculatorForm />}
      </Box>
      <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 4, mb: 2 }}>
        {'© '}
        www.amigodigital.com.ar {new Date().getFullYear()} - Versión 1.0.0
        {'.'}
      </Typography>
    </ThemeProvider>
  );
}

export default App;